import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import Button from '../Parts/Button';
import MuiButton from "material-ui/Button";
import Typography from 'material-ui/Typography';
import Checkbox from 'material-ui/Checkbox';
import Setting from '../Icons/Setting'
import Syncing from "../Icons/Syncing";
import Section from '../common/Section';
import SubmenuSection from '../common/SubmenuSection';
import Submenu from '../common/Submenu';
import DateRangePickerDialog from '../common/DateRangePickerDialog';
import { HouseListDirectory } from '../../constants/ComponentTypes';
import { sentStatusMenu, followCallOrderStatusMenu, linkCorporationStatusMenu, honorificNestedMenu, departmentNestedMenu, prefectureNameMenu, differenceTypeMenu, statusMenu, warningTypeMenu } from '../../constants/SidebarValues';
import { SentDateRangeDialogType, FollowCallOrderDateRangeDialogType } from "../../constants/ComponentTypes";
import { getLastUpdateText , flattenNestedMenu} from '../../utils/utils';
import { isEnableFollowCallHouseList, isIntegrateSalesforce } from '../../utils/userOptionUtils'

const { Set, Map } = require('immutable');

const styles = () => ({
  container: {
    width: '100%',
    height: '100%',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },

  title: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    background: '#FFFFFF',
    padding: '25px 20px',
    marginBottom: '2px',
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  content: {
    overflowY: 'scroll',
    padding: '25px 25px 100px 25px',
    width: '100%',
    boxSizing: 'border-box',
  },

  bottomMenuContainer: {
    width: "100%",
    position: 'absolute',
    bottom: 0,
  },

  bottomMenu: {
    width: "100%",
    height: "60px",
    minHeight: "60px",
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
    background: '#FFFFFF',
    boxShadow: '11px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    color: "#181819",
    padding: '0px 35px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  btn: {
    borderRadius: '2px',
    padding: '10px 18px',
    fontSize: 13,
    color: '#FFFFFF',
    backgroundColor: '#1A65FF',
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  targetList: {
    border: '1px solid #E7E9EB',
    background: '#FAFAFA',
    padding: '20px 15px',
    width: '100%',
  },

  salesforceSyncBox: {
    border: '1px solid #E7E9EB',
    background: '#FAFAFA',
    padding: '10px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '12px',
    color: '#5A5B62',
    width: '100%',
    boxSizing: 'border-box',
  },

  syncButton: {
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    color: "#181819",
    fontSize: "11px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px 7px",
    height: "25px",
    width: "55px",
    whiteSpace: "nowrap",
  },

  flexWrap: {
    display: "flex",
    flexWrap: "wrap",
  },

  nowrap: {
    whiteSpace: "nowrap",
  },

  sectionHeader: {
    marginBottom: '12px',
  },

  sectionBody: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
  },

  entry: {
    width: '100%',
    marginTop: 8,
    display: 'inline-flex',
    alignItems: 'flex-start',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  text: {
    marginLeft: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
});

const honorificMenu = flattenNestedMenu(honorificNestedMenu);
const departmentMenu = flattenNestedMenu(departmentNestedMenu);
class AddressBookSidebar extends React.Component {
  initialState = {
    tag: Set(),
    prefecture_name: Map(),
    sent_status: Map(),
    follow_call_order_status: Map(),
    follow_call_order_only_from: '',
    follow_call_order_only_to: '',
    follow_call_order_except_from: '',
    follow_call_order_except_to: '',
    letter_order_address: false,
    follow_call_address: false,
    salesforce_address: false,
    sent_only_from: '',
    sent_only_to: '',
    sent_except_from: '',
    sent_except_to: '',
    link_corporation_status: Set(),
    position: Set(),
    branch: Set(),
    import_history_tag: Set(),
    difference_type: Set(),
    timeline_status: Map(),
    warning_type: Set(),
    search: '',
    showSentDateRangePickerDialog: false,
    showFollowCallOrderDateRangePickerDialog: false,
    dateRangePickerDialogType: null,
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentWillMount() {
    this.setState(this.props.filterValue);
  }

  componentWillUnmount() {
    if (this.contentRef) {
      this.contentRef.removeEventListener('keydown', this.handleEnterKeyPressed);
      this.contentRef.removeEventListener('scroll', this.handleScroll);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.isEqual(this.props.filterValue, nextProps.filterValue)) {
      this.setState(nextProps.filterValue);
    }
  }

  toggleSentDateRangePickerDialog = (type = null) => {
    let dialogType = type;
    if (type) {
      dialogType = type === '注文済みキーマンのみを表示' ? SentDateRangeDialogType.SENT_ONLY : SentDateRangeDialogType.SENT_EXCEPT;
    }
    this.setState({
      showSentDateRangePickerDialog: !this.state.showSentDateRangePickerDialog,
      dateRangePickerDialogType: dialogType,
    });
  }

  toggleFollowCallOrderDateRangePickerDialog = (type = null) => {
    let dialogType = type;
    if (type) {
      dialogType = type === 'フォローコール依頼済みのみを表示' ? FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY : FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_EXCEPT;
    }
    this.setState({
      showFollowCallOrderDateRangePickerDialog: !this.state.showFollowCallOrderDateRangePickerDialog,
      dateRangePickerDialogType: dialogType,
    });
  }

  deselectAll = (property) => () => {
    if (property === 'prefecture_name') {
      this.setState({
        [property]: Map(),
      })
    } else {
      this.setState({
        [property]: Set(),
      })
    }
  }

  selectAll = (property, menuItems) => () => {
    if (property === 'prefecture_name') {
      let map = Map();

      if (menuItems) {
        menuItems.forEach(item => {
          let set = Set();
          item.submenu.forEach(menuItem => {
            set = set.add(menuItem.value);
          })
          map = map.set(item.value, set);
        })

        this.setState({
          [property]: map,
        })
      }
    } else {
      let set = Set();

      if (menuItems) {
        menuItems.forEach(item => {
          set = set.add((item.id || item.value).toString());
        })

        this.setState({
          [property]: set,
        })
      }
    }
  }

  handleSelect = property => value => {
    if (this.state.hasOwnProperty(property)) {
      let set = this.state[property];
      if (set.includes(value)) {
        this.setState({
          [property]: set.delete(value),
        })
      } else {
        this.setState({
          [property]: set.add(value),
        })
      }
    }
  }

  handleSelectParent = (property, menu) => value => {
    let parent = this.state[property];
    let state = {};

    if (parent) {
      if (parent.has(value)) {
        parent = parent.delete(value);
        state = {
          [property]: parent,
        };
        // 送信ステータスのチェックが外された場合は日付範囲も削除する
        if (property === 'sent_status') {
          const name = menu.find(item => item.value === value).name;
          let startDate, endDate;
          if (name === '注文済みキーマンのみを表示') {
            startDate = 'sent_only_from';
            endDate = 'sent_only_to';
          } else if (name === '注文済みキーマンを除外') {
            startDate = 'sent_except_from';
            endDate = 'sent_except_to';
          }
          state[startDate] = '';
          state[endDate] = '';
        }
        // フォローコール依頼済みのチェックが外された場合は日付範囲も削除する
        if (property === 'follow_call_order_status') {
          const name = menu.find(item => item.value === value).name;
          let startDate, endDate;
          if (name === 'フォローコール依頼済みのみを表示') {
            startDate = 'follow_call_order_only_from';
            endDate = 'follow_call_order_only_to';
          } else if (name === 'フォローコール依頼済みを除外') {
            startDate = 'follow_call_order_except_from';
            endDate = 'follow_call_order_except_to';
          }
          state[startDate] = '';
          state[endDate] = '';
        }
      } else {
        let submenu = Set();
        let entry = menu.find(item => item.value === value);

        if (entry) {
          entry.submenu.forEach(item => {
            submenu = submenu.add(item.value);
          })
        }

        parent = parent.set(value, submenu);
        state = {
          [property]: parent,
        };
      }

      this.setState(state)
    }
  }

  handleSelectChild = (property) => (parentValue, childValue) => {
    let parent = this.state[property];
    let children = parent.get(parentValue);
    let state = {};

    if (childValue === undefined) {
      children = Set();
    }

    if (children) {
      if (children.has(childValue)) {
        children = children.delete(childValue);
      } else {
        children = children.add(childValue);
      }
    }

    if (children.size === 0) {
      parent = parent.delete(parentValue);
      state = {
        [property]: parent,
      };
      // 送信ステータスのチェックが外された場合は日付範囲も削除する
      if (property === 'sent_status') {
        const name = sentStatusMenu.find(item => item.value === parentValue).name
        let startDate, endDate;
        if (name === '注文済みキーマンのみを表示') {
          startDate = 'sent_only_from';
          endDate = 'sent_only_to';
        } else if (name === '注文済みキーマンを除外') {
          startDate = 'sent_except_from';
          endDate = 'sent_except_to';
        }
        state[startDate] = '';
        state[endDate] = '';
      }
      // フォローコール依頼済みのチェックが外された場合は日付範囲も削除する
      if (property === 'follow_call_order_status') {
        const name = followCallOrderStatusMenu.find(item => item.value === parentValue).name;
        let startDate, endDate;
        if (name === 'フォローコール依頼済みのみを表示') {
          startDate = 'follow_call_order_only_from';
          endDate = 'follow_call_order_only_to';
        } else if (name === 'フォローコール依頼済みを除外') {
          startDate = 'follow_call_order_except_from';
          endDate = 'follow_call_order_except_to';
        }
        state[startDate] = '';
        state[endDate] = '';
      }
    } else {
      parent = parent.set(parentValue, children);
      state = {
        [property]: parent,
      };
    }

    this.setState(state);
  }

  handleReset = () => {
    this.setState(this.initialState)
  }

  handleChange = (e) => {
    this.setState({
      search: e.target.value,
    })
  }

  handleClick = () => {
    if (this.props.isDemo) {
      this.props.togglePlanDialog();
    } else {
      let {
        showSentDateRangePickerDialog: _showSentDateRangePickerDialog,
        showFolloWCallOrderDateRangePickerDialog: _showFolloWCallOrderDateRangePickerDialog,
        dateRangePickerDialogType: _dateRangePickerDialogType,
        ...filterValue
      } = this.state;
      this.props.updateFilter(filterValue);
    }
  }

  handleCheck = (property) => () => {
    this.setState({
      [property]: !this.state[property],
    })
  }

  handleScroll = () => {
    const maxScrollTop = 20;
    if (this.contentRef && this.titleRef && this.contentRef.scrollTop > maxScrollTop) {
      this.titleRef.style.boxShadow = '0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
    } else {
      this.titleRef.style.boxShadow = 'none'
    }
  }

  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      if (this.hasSelection(this.props.filterValue)) {
        this.handleClick();
      }
    }
  }

  handleDataRangeFilterSet = (filter, dialogType) => {
    const { sent_only_from, sent_only_to, sent_except_from, sent_except_to, follow_call_order_only_from, follow_call_order_only_to, follow_call_order_except_from, follow_call_order_except_to } = this.state;
    let itemValue = '';
    let state = {};
    let parent, menu, property;

    if (dialogType.includes('sent')) {
      // 注文済みキーマンの日付範囲選択の場合
      parent = this.state.sent_status;
      menu = sentStatusMenu;
      property = 'sent_status';

      // 日付範囲が選択された場合
      if (filter && filter.sent_only_from && filter.sent_only_to &&
        (sent_only_from !== filter.sent_only_from || sent_only_to !== filter.sent_only_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済みキーマンのみを表示').value;
      }
      if (filter && filter.sent_except_from && filter.sent_except_to &&
        (sent_except_from !== filter.sent_except_from || sent_except_to !== filter.sent_except_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済みキーマンを除外').value;
      }
    } else if (dialogType.includes('follow_call_order')) {
      // フォローコール依頼済みの日付範囲選択の場合
      parent = this.state.follow_call_order_status;
      menu = followCallOrderStatusMenu;
      property = 'follow_call_order_status';

      // 日付範囲が選択された場合
      if (filter && filter.follow_call_order_only_from && filter.follow_call_order_only_to &&
        (follow_call_order_only_from !== filter.follow_call_order_only_from || follow_call_order_only_to !== filter.follow_call_order_only_to)
      ) {
        itemValue = menu.find(item => item.name === 'フォローコール依頼済みのみを表示').value;
      }
      if (filter && filter.follow_call_order_except_from && filter.follow_call_order_except_to &&
        (follow_call_order_except_from !== filter.follow_call_order_except_from || follow_call_order_except_to !== filter.follow_call_order_except_to)
      ) {
        itemValue = menu.find(item => item.name === 'フォローコール依頼済みを除外').value;
      }
    }

    if (itemValue) {
      // 日付範囲が選択された場合で絞り込みオプションにチェックボックスにされていない場合はチェックする
      if (!this.state[property].has(itemValue)) {
        let submenu = Set();
        let entry = menu.find(item => item.value === itemValue);
        if (entry) {
          entry.submenu.forEach(item => {
            submenu = submenu.add(item.value);
          })
        }
        parent = parent.set(itemValue, submenu);
        state = {
          [property]: parent,
        };
      }
      this.setState({ ...filter, ...state })
    }
  }

  setContentRef = (node) => {
    this.contentRef = node;
    if (this.contentRef) {
      this.contentRef.addEventListener('keydown', this.handleEnterKeyPressed, false);
      this.contentRef.addEventListener('scroll', this.handleScroll, false);
    }
  }

  setTitleRef = (node) => {
    this.titleRef = node;
  }

  hasSelection = (filterValue) => {
    return (
      !this.state.tag.equals(filterValue.tag) ||
      !this.state.import_history_tag.equals(filterValue.import_history_tag) ||
      !this.state.link_corporation_status.equals(filterValue.link_corporation_status) ||
      !this.state.position.equals(filterValue.position) ||
      !this.state.branch.equals(filterValue.branch) ||
      !this.state.difference_type.equals(filterValue.difference_type) ||
      !this.state.prefecture_name.equals(filterValue.prefecture_name) ||
      !this.state.timeline_status.equals(filterValue.timeline_status) ||
      !this.state.sent_status.equals(filterValue.sent_status) ||
      !this.state.follow_call_order_status.equals(filterValue.follow_call_order_status) ||
      !this.state.warning_type.equals(filterValue.warning_type) ||
      this.state.letter_order_address !== filterValue.letter_order_address ||
      this.state.follow_call_address !== filterValue.follow_call_address ||
      this.state.salesforce_address !== filterValue.salesforce_address ||
      this.state.sent_only_from !== filterValue.sent_only_from ||
      this.state.sent_only_to !== filterValue.sent_only_to ||
      this.state.sent_except_from !== filterValue.sent_except_from ||
      this.state.sent_except_to !== filterValue.sent_except_to ||
      this.state.follow_call_order_only_from !== filterValue.follow_call_order_only_from ||
      this.state.follow_call_order_only_to !== filterValue.follow_call_order_only_to ||
      this.state.follow_call_order_except_from !== filterValue.follow_call_order_except_from ||
      this.state.follow_call_order_except_to !== filterValue.follow_call_order_except_to ||
      this.state.search !== filterValue.search)
  }

  isEqual(curr, next) {
    if (!!curr && !!next) {
      let currVals = Object.values(curr);
      let nextVals = Object.values(next);

      if (currVals.length !== nextVals.length) return false;

      let equal = true;

      currVals.forEach((currItem, i) => {
        if (typeof currItem === 'string') {
          equal = equal && (currItem === nextVals[i]);
        } else if (typeof currItem === 'boolean') {
          equal = equal && (currItem === nextVals[i]);
        } else {
          if (currItem) {
            equal = equal && (currItem.equals(nextVals[i]));
          }
        }
      })

      return equal;
    }

    return false;
  }

  renderSentDateRangePickerDialog = () => {
    const { dateRangePickerDialogType, sent_only_from, sent_only_to, sent_except_from, sent_except_to } = this.state;

    return (
      <DateRangePickerDialog
        isOpen={this.state.showSentDateRangePickerDialog}
        toggleDialog={this.toggleSentDateRangePickerDialog}
        dialogType={dateRangePickerDialogType}
        dataRangeFilterSet={this.handleDataRangeFilterSet}
        title={'注文日で絞り込み'}
        user={this.props.user}
        orderList={this.props.letterOrderList}
        from={dateRangePickerDialogType === SentDateRangeDialogType.SENT_ONLY ? sent_only_from : sent_except_from}
        to={dateRangePickerDialogType === SentDateRangeDialogType.SENT_ONLY ? sent_only_to : sent_except_to}
        isExe={false}
      />
    )
  }

  renderFollowCallOrderDateRangePickerDialog = () => {
    const { dateRangePickerDialogType, follow_call_order_only_from, follow_call_order_only_to, follow_call_order_except_from, follow_call_order_except_to } = this.state;

    return (
      <DateRangePickerDialog
        isOpen={this.state.showFollowCallOrderDateRangePickerDialog}
        toggleDialog={this.toggleFollowCallOrderDateRangePickerDialog}
        dialogType={dateRangePickerDialogType}
        dataRangeFilterSet={this.handleDataRangeFilterSet}
        title={'依頼日で絞り込み'}
        user={this.props.user}
        orderList={this.props.followCallOrderList}
        from={dateRangePickerDialogType === FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY ? follow_call_order_only_from : follow_call_order_except_from}
        to={dateRangePickerDialogType === FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY ? follow_call_order_only_to : follow_call_order_except_to}
        isExe={false}
      />
    )
  }

  render() {
    const { classes, disabled, lastUpdate, user } = this.props;
    const showSalesforceSection = user && user.integrations.salesforce && !!user.salesforce_import_mapping;
    let sentDateRangePickerDialog, followCallOrderDateRangePickerDialog;

    if (this.state.showSentDateRangePickerDialog) {
      sentDateRangePickerDialog = this.renderSentDateRangePickerDialog();
    }
    if (this.state.showFollowCallOrderDateRangePickerDialog) {
      followCallOrderDateRangePickerDialog = this.renderFollowCallOrderDateRangePickerDialog();
    }

    return (
      <div className={classes.container} style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
        <div className={classes.title} ref={this.setTitleRef}>
          <Setting height={20} width={20} color="#B1B3B9" style={{ marginRight: '10px' }} />
          <Typography variant="subheading" style={{ color: disabled ? '#B1B3B9' : '#181819', flex: 1 }}>
            複数条件で絞り込む
          </Typography>

          {(() => {
            if (this.hasSelection(this.initialState)) {
              return (
                <Button
                  text="リセット"
                  type="ghost"
                  size="extra-small"
                  handleClickButton={this.handleReset}
                  style={{
                    color: disabled ? '#B1B3B9' : '#71737B',
                    border: 'none',
                    minWidth: 'unset',
                    width: 'unset',
                    padding: '0px 5px',
                    height: 'unset',
                  }}
                />
              )
            }
          })()}
        </div>

        <div ref={this.setContentRef} className={classes.content}>
          <Section
            title="フリーワード"
            disabled={this.props.disabled}
            tooltipText={"複数のフリーワードは空白で区切って入力してください。"}
            toolTipPlacement={"bottom"}
          >
            <TextField
              id="search"
              type="search"
              placeholder="oo株式会社 取締役"
              value={this.state.search}
              onChange={this.handleChange}
              InputProps={{
                disableUnderline: true,
              }}
              fullWidth
            />
          </Section>

          {(() => {
            if (this.props.type === HouseListDirectory.MAIN.name && showSalesforceSection) {
              return (
                <Section
                  title="Salesforceリスト"
                  disabled={this.props.disabled}
                >
                  <div className={classes.salesforceSyncBox}>
                    <div className={classes.flexWrap}>
                      <span className={classes.nowrap}>最終同期: </span>
                      <span className={classes.nowrap}>
                        {getLastUpdateText(lastUpdate)}
                      </span>
                    </div>
                    <MuiButton
                      className={classes.syncButton}
                      onClick={this.props.postSalesforceSync}
                      disabled={this.props.isImporting}
                      style={{
                        background: this.props.isImporting
                          ? "#F2F6FF"
                          : "transparent",
                      }}
                    >
                      <Syncing
                        width={11}
                        height={11}
                        color={
                          this.props.isImporting ? "#5593FF" : "#71737B"
                        }
                        style={{ display: "block" }}
                      />
                      {!this.props.isImporting && (
                        <span style={{ marginLeft: "6px" }}>同期</span>
                      )}
                    </MuiButton>
                  </div>
                </Section>
              )
            }
          })()}

          {(() => {
            if (this.props.type === HouseListDirectory.WARNING.name) {
              return (
                <Section
                  title="警告の種類"
                  menuItems={warningTypeMenu}
                  deselectAll={this.deselectAll('warning_type')}
                  selectAll={this.selectAll('warning_type', warningTypeMenu)}
                  select={this.handleSelect('warning_type')}
                  set={this.state.warning_type}
                  disabled={this.props.disabled}
                />
              )
            }
          })()}

          <Section
            title="リスト"
            classes={{
              sectionHeader: classes.sectionHeader
            }}
            menuItems={this.props.tags.map(tag => ({ name: tag, value: tag }))}
            selectAll={this.selectAll('tag', this.props.tags.map(tag => ({ name: tag, value: tag })))}
            deselectAll={this.deselectAll('tag')}
            select={this.handleSelect('tag')}
            set={this.state.tag}
            disabled={this.props.disabled}
            controls={[{
              text: '管理',
              action: this.props.toggleManageTagsDialog
            }]}
          />

          {(this.props.type === HouseListDirectory.MAIN.name) && (<Section
            title="絞り込みオプション"
            disabled={this.props.disabled}
            classes={{
              sectionHeader: classes.sectionHeader
            }}>
            <div>
              <Submenu
                user={user}
                menuItems={sentStatusMenu}
                select={this.handleSelectParent('sent_status', sentStatusMenu)}
                set={this.state.sent_status}
                disabled={this.props.disabled}
                toggleDateRangePickerDialog={this.toggleSentDateRangePickerDialog}
                selectSubmenu={this.handleSelectChild('sent_status')}
              />
              {isEnableFollowCallHouseList(user) && (
                <React.Fragment>
                  <Submenu
                    user={user}
                    menuItems={followCallOrderStatusMenu}
                    select={this.handleSelectParent('follow_call_order_status', followCallOrderStatusMenu)}
                    set={this.state.follow_call_order_status}
                    disabled={this.props.disabled}
                    toggleDateRangePickerDialog={this.toggleFollowCallOrderDateRangePickerDialog}
                    selectSubmenu={this.handleSelectChild('follow_call_order_status')}
                  />
                  <div className={classes.entry} onClick={this.handleCheck('letter_order_address')}>
                    <Checkbox
                      color="primary"
                      checked={this.state.letter_order_address}
                      onChange={this.handleCheck('letter_order_address')}
                      style={{
                        width: '20px',
                        height: '20px',
                      }}
                      disabled={this.props.disabled}
                    />
                    <Typography
                      variant="subheading"
                      className={classes.text}
                      style={{ color: this.props.disabled ? '#B1B3B9' : '#181819' }}
                    >
                      レター送付アドレスを表示
                    </Typography>
                  </div>
                  <div className={classes.entry} onClick={this.handleCheck('follow_call_address')} style={{ marginTop: 4 }}>
                    <Checkbox
                      color="primary"
                      checked={this.state.follow_call_address}
                      onChange={this.handleCheck('follow_call_address')}
                      style={{
                        width: '20px',
                        height: '20px',
                      }}
                      disabled={this.props.disabled}
                    />
                    <Typography
                      variant="subheading"
                      className={classes.text}
                      style={{ color: this.props.disabled ? '#B1B3B9' : '#181819' }}
                    >
                      フォローコールアドレスを表示
                    </Typography>
                  </div>
                </React.Fragment>
              )}
              {isIntegrateSalesforce(user) && (
                <React.Fragment>
                  <div className={classes.entry} onClick={this.handleCheck('salesforce_address')} style={{ marginTop: 4 }}>
                    <Checkbox
                      color="primary"
                      checked={this.state.salesforce_address}
                      onChange={this.handleCheck('salesforce_address')}
                      style={{
                        width: '20px',
                        height: '20px',
                      }}
                      disabled={this.props.disabled}
                    />
                    <Typography
                      variant="subheading"
                      className={classes.text}
                      style={{ color: this.props.disabled ? '#B1B3B9' : '#181819' }}
                    >
                      Salesforceアドレスを表示
                    </Typography>
                  </div>
                </React.Fragment>
              )}
            </div>
          </Section>)}

          {(this.props.type === HouseListDirectory.MAIN.name) && (<SubmenuSection
            title="ステータス"
            user={user}
            menuItems={statusMenu}
            deselectAll={this.deselectAll('timeline_status')}
            selectAll={this.selectAll('timeline_status', statusMenu)}
            select={this.handleSelectParent('timeline_status', statusMenu)}
            set={this.state.timeline_status}
            disabled={this.props.disabled}
            selectSubmenu={this.handleSelectChild('timeline_status')}
          />)}

          <Section
            title="役職"
            classes={{
              sectionHeader: classes.sectionHeader
            }}
            menuItems={honorificMenu}
            deselectAll={this.deselectAll('position')}
            selectAll={this.selectAll('position', honorificMenu)}
            select={this.handleSelect('position')}
            set={this.state.position}
            disabled={this.props.disabled}
          />

          <Section
            title="部門"
            classes={{
              sectionHeader: classes.sectionHeader
            }}
            menuItems={departmentMenu}
            deselectAll={this.deselectAll('branch')}
            selectAll={this.selectAll('branch', departmentMenu)}
            select={this.handleSelect('branch')}
            set={this.state.branch}
            disabled={this.props.disabled}
          />

          <SubmenuSection
            title="地域"
            menuItems={prefectureNameMenu}
            deselectAll={this.deselectAll('prefecture_name')}
            selectAll={this.selectAll('prefecture_name', prefectureNameMenu)}
            select={this.handleSelectParent('prefecture_name', prefectureNameMenu)}
            set={this.state.prefecture_name}
            disabled={this.props.disabled}
            selectSubmenu={this.handleSelectChild('prefecture_name')}
          />

          <Section
            title="インポート履歴"
            classes={{
              sectionHeader: classes.sectionHeader
            }}
            menuItems={this.props.importHistories.map(tag => ({ name: tag, value: tag }))}
            selectAll={this.selectAll('import_history_tag', this.props.importHistories.map(tag => ({ name: tag, value: tag })))}
            deselectAll={this.deselectAll('import_history_tag')}
            select={this.handleSelect('import_history_tag')}
            set={this.state.import_history_tag}
            disabled={this.props.disabled}
          />

          {(() => {
            if (this.props.type === HouseListDirectory.MAIN.name) {
              return (
                <Section
                  title="登記簿変更の有無"
                  classes={{
                    sectionHeader: classes.sectionHeader
                  }}
                  menuItems={differenceTypeMenu}
                  deselectAll={this.deselectAll('difference_type')}
                  selectAll={this.selectAll('difference_type', differenceTypeMenu)}
                  select={this.handleSelect('difference_type')}
                  set={this.state.difference_type}
                  disabled={this.props.disabled}
                />
              )
            }
          })()}

          {(() => {
            if (this.props.type === HouseListDirectory.MAIN.name) {
              return (
                <Section
                  title="法人番号の紐付け"
                  classes={{
                    sectionHeader: classes.sectionHeader
                  }}
                  menuItems={linkCorporationStatusMenu}
                  deselectAll={this.deselectAll('link_corporation_status')}
                  selectAll={this.selectAll('link_corporation_status', linkCorporationStatusMenu)}
                  select={this.handleSelect('link_corporation_status')}
                  set={this.state.link_corporation_status}
                  disabled={this.props.disabled}
                />
              )
            }
          })()}
        </div>

        <div
          className={classes.bottomMenuContainer}
        >
          <div
            className={classes.bottomMenu}
            style={{
              transform: this.hasSelection(this.props.filterValue) ? 'translateY(0%)' : 'translateY(100%)',
              visibility: this.hasSelection(this.props.filterValue) ? 'visible' : 'hidden'
            }}>
            <Button
              text="絞り込む"
              handleClickButton={this.handleClick}
              loading={this.props.isFiltering}
              fullWidth={true}
            >
              絞り込む
            </Button>
          </div>
        </div>
        {sentDateRangePickerDialog}
        {followCallOrderDateRangePickerDialog}
      </div>
    );
  }
}

AddressBookSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  tags: PropTypes.array,
  disabled: PropTypes.bool,
  importHistories: PropTypes.array,
  isFiltering: PropTypes.bool.isRequired,
  updateFilter: PropTypes.func.isRequired,
  filterValue: PropTypes.object,
  type: PropTypes.string.isRequired,
  toggleManageTagsDialog: PropTypes.func,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
  user: PropTypes.object,
  postSalesforceSync: PropTypes.func,
  isImporting: PropTypes.bool,
  lastUpdate: PropTypes.string,
  letterOrderList: PropTypes.array,
  followCallOrderList: PropTypes.array,
};

export default withStyles(styles)(AddressBookSidebar);



// WEBPACK FOOTER //
// ./src/components/AddressBook/AddressBookSidebar.jsx